<template>
    <div>
        <m-assembly-table
            :formData="formData"
            :columns="columns"
            :data="tableData"
            :currentPage="settings.currentPage"
            :pageSize="settings.pageSize"
            :settings="settings"
            :tableButtons="tableButtons"
            :loading="loading"
            :total="settings.total"
            @onSelectionChange="onSelectionChange"
            ref="searchForm">
        </m-assembly-table>

        <SearchDialog :formData="sDialog.formData"
                      :loading="sDialog.loading"
                      :modalWidth="sDialog.modalWidth"
                      :tableColumns="sDialog.tableColumns"
                      :tableData="sDialog.tableData"
                      :currentPage="sDialog.page"
                      :pageSize="sDialog.pageSize"
                      :totalpages="sDialog.total"
                      highlightRow
                      @on-page-change="sDialogOnPageChange"
                      @on-page-size-change="sDialogOnPageSizeChange"
                      @handleSearch="handleSearchDialog"
                      @handleSelect="handleSelectDialog"
                      ref="sDialog"
        ></SearchDialog>

        <!-- 批量导入 -->
        <Modal v-model="importModal.show"
               :title="this.$t('UIDLabelPrint.t35')"
               :width="500">
                <div style="text-align: center;">
                    <Upload
                        :format="['xls', 'xlsx']"
                        :show-upload-list="false"
                        ref="importFile"
                        :before-upload="importBeforeUpload"
                        :on-success="importOnSuccess"
                        :on-error="importOnError"
                        :action="importUrl">
                        <Button type="ghost" size="small" :loading="importModal.loading">{{
                            this.$t('UIDLabelPrint.t37') }}
                        </Button>
                    </Upload>
                    <p style="margin: 10px 0;">{{ $t('UIDLabelPrint.t38') }}</p><!--请下载数据导入模板，并按照模板格式填写需导入的数据-->
                    <Button size="small" type="primary" :loading="importModal.loading" @click="downloadImportFile">{{ $t('UIDLabelPrint.t36') }}</Button> <!-- 模版下载 -->
                    <div style="margin-top:10px;">
                        <Button type="error" size="small" v-if="importModal.handleNum" @click="downloadErrorFile">{{ $t('UIDLabelPrint.t40') }}</Button> <!--下载错误信息-->
                    </div>
                    <!-- <p style="margin:10px 0;color:red;cursor:pointer;"></p> -->
                </div>
                <div slot="footer"></div>
        </Modal>
    </div>
</template>
<script>
import mAssemblyTable from '@/components/awesome/page/assembly_table';
import SearchDialog from '@/components/awesome/page/search_dialog';
import axios from 'axios';
import moment from 'moment';
import { exportExcel } from '@/utils/tool';

export default {
    name: 'UIDLabelPrint',
    components: {
        mAssemblyTable,
        SearchDialog,
    },
    computed: {
        formModel() {
            return this.getFormDataVModel(this.formData.items);
        },
        language() {
            return this.switchLanguage(this.$i18n.locale);
        },
    },
    watch: {
        'importModal.show'(newVal) {
            if (newVal) {
                this.importModal.handleNum = '';
            }
        },
    },
    data() {
        return {
            formData: {
                row: 4,
                items: [
                    {
                        value: '',
                        field: 'orgCode',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('UIDLabelPrint.t1'), // 买方组织不能为空
                            },
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        methods: {
                            change: () => {
                                this.formValSet('itemCode', '');
                                this.formValSet('itemDescription', '');
                            },
                        },
                        options: {
                            multiple: false,
                            values: [],
                        },
                        type: 'select',
                        title: this.$t('UIDLabelPrint.t2'), // 买方组织
                    },
                    {
                        value: '',
                        field: 'vendorCode',
                        readonly: true,
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('UIDLabelPrint.t3'), // 供应商编码不能为空
                            },
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('UIDLabelPrint.t4'), // 供应商编码
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'vendorNameAlt',
                        readonly: true,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('UIDLabelPrint.t28'), // 供应商简称
                    },
                    {
                        value: '',
                        field: 'itemCode',
                        readonly: true,
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('UIDLabelPrint.t5'), // 物料编码不能为空
                            },
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        canClick: true,
                        title: this.$t('UIDLabelPrint.t6'), // 物料编码
                        click: () => {
                            if (!this.$refs.searchForm.validateFieldForm(0)) {
                                this.$refs.sDialog.show = true;
                            }
                        },
                    },
                    {
                        value: '',
                        field: 'itemDescription',
                        readonly: true,
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('UIDLabelPrint.t7'), // 物料描述不能为空
                            },
                        },
                        layout: {
                            span: 16,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('UIDLabelPrint.t8'), // 物料描述
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'unit',
                        layout: {
                            span: 16,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('UIDLabelPrint.t29'), // 单位
                    },
                    {
                        value: '',
                        field: 'partType',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('UIDLabelPrint.t9'), // 物料型号/材质
                    },
                    {
                        value: '',
                        field: 'lotNo',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('UIDLabelPrint.t10'), // 批次号不能为空
                            },
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 3,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('UIDLabelPrint.t11'), // 批次号
                    },
                    {
                        value: '',
                        field: 'mdate',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('UIDLabelPrint.t12'), // 生产日期不能为空
                            },
                        },
                        layout: {
                            row: 3,
                            span: 8,
                            offset: 0,
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd',
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: this.$t('UIDLabelPrint.t13'), // 生产日期
                        placeholder: '',
                    },
                    {
                        value: null,
                        field: 'qty',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('UIDLabelPrint.t14'), // 最小包装数量不能为空
                            },
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 3,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        style: {
                            width: '100%',
                        },
                        type: 'number',
                        title: this.$t('UIDLabelPrint.t15'), // 最小包装数量
                    },
                    {
                        value: null,
                        field: 'tagCount',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('UIDLabelPrint.t16'), // 标签数量不能为空
                            },
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 4,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                            min: 1,
                            max: 100,
                        },
                        style: {
                            width: '100%',
                        },
                        type: 'number',
                        title: this.$t('UIDLabelPrint.t17'), // 标签数量
                    },
                    {
                        value: '',
                        field: 'expirtDate',
                        disabled: false,
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('UIDLabelPrint.t18'), // 过期日期不能为空
                            },
                        },
                        layout: {
                            row: 4,
                            span: 8,
                            offset: 0,
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd',
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: this.$t('UIDLabelPrint.t19'), // 过期日期
                        placeholder: '',
                    },
                ],
            },
            columns: {
                columns: [
                    // {
                    //     type: 'selection',
                    //     align: 'center',
                    //     width: 35,
                    // },
                    {
                        title: this.$t('UIDLabelPrint.t26'), // 序号
                        type: 'index',
                        align: 'center',
                        width: 35,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t27'), // 供应商编码
                        key: 'vendorCode',
                        align: 'center',
                        width: 70,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t28'), // 供应商简称
                        key: 'vendorNameAlt',
                        align: 'center',
                        tooltip: true,
                        width: 70,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t9'), // 物料型号/材质
                        key: 'partType',
                        width: 150,
                        tooltip: true,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t6'), // 物料编码
                        key: 'itemCode',
                        align: 'center',
                        width: 110,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t8'), // 物料描述
                        key: 'itemDescription',
                        minWidth: 250,
                        tooltip: true,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t15'), // 最小包装数量
                        key: 'qty',
                        align: 'right',
                        width: 50,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t29'), // 单位
                        key: 'unit',
                        align: 'center',
                        width: 50,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t11'), // 批次号
                        key: 'lotNo',
                        align: 'center',
                        width: 100,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t13'), // 生产日期
                        key: 'mdate',
                        align: 'center',
                        width: 80,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t19'), // 过期日期
                        key: 'expirtDate',
                        align: 'center',
                        width: 80,
                    },
                ],
            },
            tableData: [],
            tableButtons: {
                customButtons: [
                    {
                        name: '',
                        label: this.$t('UIDLabelPrint.t20'), // 重置已生成标签
                        type: 'primary',
                        icon: 'ios-down',
                        loading: false,
                        disabled: () => this.tableData.length === 0,
                        click: () => {
                            this.formItemsToggle(false);
                            this.tableData = [];
                        },
                    },
                    {
                        name: '',
                        label: this.$t('UIDLabelPrint.t21'), // 生成标签
                        type: 'primary',
                        icon: 'ios-down',
                        loading: false,
                        click: () => {
                            if (this.$refs.searchForm.validateForm()) {
                                this.importModal.flag = false;
                                this.createTag();
                            }
                        },
                    },
                    {
                        name: '',
                        label: this.$t('UIDLabelPrint.t22'), // 打印标签
                        type: 'primary',
                        icon: 'ios-down',
                        loading: false,
                        disabled: () => this.tableData.length === 0,
                        click: (button) => {
                            button.loading = true;
                            if (this.importModal.flag) {
                                this.importPrint()
                                    .finally(() => {
                                        button.loading = false;
                                    });
                            } else {
                                this.printUIDTag()
                                    .finally(() => {
                                        button.loading = false;
                                    });
                            }
                        },
                    },
                    {
                        name: '',
                        label: this.$t('UIDLabelPrint.t23'), // 补打标签
                        type: 'primary',
                        icon: 'ios-down',
                        loading: false,
                        click: () => {
                            this.$router.push({
                                name: 'UIDLabelPrintHistory',
                            });
                        },
                    },
                    {
                        name: '',
                        label: this.$t('UIDLabelPrint.t24'), // 批量生成（模版下载）
                        type: 'primary',
                        icon: 'ios-down',
                        loading: false,
                        click: () => {
                            this.importModal.show = true;
                        },
                    },
                    {
                        name: '',
                        label: this.$t('UIDLabelPrint.t25'), // 清除
                        type: 'primary',
                        icon: 'ios-down',
                        loading: false,
                        click: () => {
                            this.formData.items.forEach((item) => {
                                if (!['orgCode', 'vendorCode', 'vendorNameAlt', 'itemCode'].includes(item.field)) {
                                    item.value = item.type === 'number' ? null : '';
                                }
                                item.disabled = false;
                            });
                            this.tableData = [];
                        },
                    },
                ],
            },
            settings: {
                needPager: false,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 30, 50, 80],
                needSearch: true,
                onlyLeftPart: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: 0,
            },
            sDialog: {
                modalWidth: 800,
                loading: false,
                tableColumns: [
                    {
                        title: this.$t('UIDLabelPrint.t6'), // 物料编码
                        key: 'itemCode',
                        align: 'center',
                        width: 120,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t8'),
                        key: 'itemDescription', // 物料描述
                        minWidth: 200,
                        tooltip: true,
                    },
                    {
                        title: this.$t('UIDLabelPrint.t29'), // 单位
                        key: 'unit',
                        align: 'center',
                        width: 70,
                    },
                ],
                tableData: [],
                pageNum: 1,
                pageSize: 10,
                total: 0,
                formData: {
                    dialogTitle: this.$t('UIDLabelPrint.t30'), // 选择物料
                    searchValue: '2',
                    searchList: [
                        { label: this.$t('UIDLabelPrint.t8'), value: '1' }, // 物料描述
                        { label: this.$t('UIDLabelPrint.t6'), value: '2' }, // 物料编码
                    ],
                    inputValue: '',
                    labelWidth: 90,
                },
            },
            loading: false,
            selection: [],
            importUrl: '/gscint/uidTag/importData',
            importModal: {
                show: false,
                loading: false,
                flag: false,
                handleNum: '',
            },
        };
    },
    methods: {
        onSubmit() {},
        sDialogOnPageChange(pageNum) {
            this.sDialog1.pageNum = pageNum;
            this.handleSearchDialog();
        },
        sDialogOnPageSizeChange(pageSize) {
            this.sDialog1.pageSize = pageSize;
            this.handleSearchDialog();
        },
        handleSearchDialog() {
            this.sDialog.loading = true;
            const { searchValue, inputValue } = this.sDialog.formData;
            const { pageNum, pageSize } = this.sDialog;
            const { orgCode } = this.formModel;
            axios.post('/gscint/uidTag/getItemList', {
                vendorCode: this.vendorCode,
                orgCode,
                [searchValue === '1' ? 'itemDescription' : 'itemCode']: inputValue,
                pageNum,
                pageSize,
            })
                .then((res) => {
                    const { success, data, msg: content } = res.data;
                    if (success) {
                        const { list, total } = data;
                        this.sDialog.tableData = list;
                        this.sDialog.total = total;
                    } else {
                        this.$Modal.warning({
                            content,
                        });
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                })
                .finally(() => {
                    this.sDialog.loading = false;
                });
        },
        handleSelectDialog(data) {
            const { itemCode, itemDescription, unit } = data;
            this.formValSet('itemCode', itemCode);
            this.formValSet('itemDescription', itemDescription);
            this.formValSet('unit', unit);
            this.$refs.sDialog.show = false;
        },
        formValSet(key, val) {
            this.getFormDataItemObj(this.formData.items, key).value = val;
        },
        onSelectionChange(selection) {
            this.selection = selection;
        },
        getQrCode(uid, vendor, ipn, qty, lotNo, mdate) {
            return `@U${uid}@V${vendor}@M${ipn}@Q${qty}@L${lotNo}@D${moment(mdate).format('YYYYMMDD')}@`;
        },
        printUIDTag() {
            return axios.post('/gscint/uidTag/printUIDTag', {
                ...this.formModel,
            })
                .then(async (res) => {
                    const { datas, msg: content } = res.data.data;
                    if (datas && datas.length > 0) {
                        const { orgCode, vendorNameAlt: vendorAddress, vendorCode: vendor, itemCode: ipn, itemDescription: partDesc, partType, lotNo, mdate, qty, tagCount, expirtDate, unit } = this.formModel;
                        const reportlets = datas.reduce((prev, { tagUid: uid }) => {
                            const qrCode = this.getQrCode(uid, vendor, ipn, qty, lotNo, mdate);
                            return prev.concat({
                                uid,
                                orgCode,
                                vendorAddress,
                                vendor,
                                ipn,
                                partDesc,
                                partType,
                                lotNo,
                                mDate: mdate,
                                qty,
                                tagCount,
                                expiryDate: expirtDate,
                                unit,
                                qrCode,
                            });
                        }, []);
                        await this.cloudPrint('hw-uidTag', { reportlets });
                        this.tableData = [];
                        this.formItemsToggle(false);
                        /* 打印后重置部分字段 */
                        this.formData.items.forEach((item) => {
                            if (['itemCode', 'itemDescription', 'partType', 'lotNo', 'lotNo', 'mdate', 'qty', 'tagCount', 'expirtDate', 'unit'].includes(item.field)) {
                                item.value = '';
                            }
                        });
                    } else {
                        this.$Modal.warning({
                            content,
                        });
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                });
        },
        printFun() {

        },
        createTag() {
            this.formItemsToggle(true);
            const { tagCount } = this.formModel;
            for (let i = 0; i < tagCount; i += 1) {
                this.tableData.push({
                    ...this.formModel,
                });
            }
        },
        formItemsToggle(val) {
            this.formData.items.forEach((item) => item.disabled = val);
        },
        downloadImportFile() {
            // 中文 18eb6148ebcb6b0db60cba24a2da8b58  18eb618be1b3433930ba4024a098ca7f
            // 英文 18eb615ed85cfa9196e67124cb58574e  18eb619320847b6610a2f554e408be2f
            const ids = {
                test: {
                    cn: '18eb6148ebcb6b0db60cba24a2da8b58',
                    en: '18eefe60145ea748ed0b3bc44fe8c7cc',
                },
                prod: {
                    cn: '18eb618be1b3433930ba4024a098ca7f',
                    en: '18eefe5229eb24efbda0f4a4cb4b88e2',
                },
            };
            const languageSwitch = (urls) => {
                return this.$i18n.locale === 'zh-CN' ? urls.cn : urls.en;
            };
            window.open(`/gscint/supplierfile/downloadFile?docId=${languageSwitch(this.isPro() ? ids.prod : ids.test)}`);
        },
        importBeforeUpload() {
            this.importModal.loading = true;
        },
        importOnSuccess(res) {
            this.importModal.loading = false;
            try {
                const { code, datas, handleNum } = res.data;
                if (code === '1') {
                    this.tableData = [];
                    datas.forEach((item) => {
                        this.tableData.push({
                            ...item,
                        });
                        this.importModal.show = false;
                        this.$Modal.success({
                            content: this.$t('UIDLabelPrint.t39'), // 导入成功
                        });
                        this.importModal.flag = true;
                        this.confirmUIDTag(handleNum);
                    });
                } else {
                    // this.$Modal.warning({
                    //     content,
                    // });
                    this.importModal.handleNum = handleNum;
                }
            } catch (err) {
                this.showErrorTips();
            }
        },
        importOnError() {
            this.importModal.loading = false;
            this.showErrorTips();
        },
        confirmUIDTag(handleNum) {
            return axios.get('/gscint/uidTag/confirmUIDTag', {
                params: {
                    vendorCode: this.vendorCode,
                    handleNum,
                },
            });
        },
        importPrint() {
            const reportlets = this.tableData.reduce((prev, { tagUid: uid, orgCode, vendorCode: vendor, vendorNameAlt: vendorAddress, itemCode: ipn, itemDescription: partDesc, partType, qty, lotNo, mdate, tagCount, expirtDate, unit }) => {
                const qrCode = this.getQrCode(uid, vendor, ipn, qty, lotNo, mdate);
                return prev.concat({
                    uid,
                    orgCode,
                    vendorAddress,
                    vendor,
                    ipn,
                    partDesc,
                    partType,
                    lotNo,
                    mDate: mdate,
                    qty,
                    tagCount,
                    expiryDate: expirtDate,
                    unit,
                    qrCode,
                });
            }, []);
            return this.cloudPrint('hw-uidTag', { reportlets });
        },
        downloadErrorFile() {
            // window.open(`/gscint/uidTag/exportErrorData?vendorCode=${this.vendorCode}&handleNum=${this.importModal.handleNum}`);
            exportExcel(`/gscint/uidTag/exportErrorData?handleNum=${this.importModal.handleNum}&language=${this.language}`, {}, `${this.$t('route.UIDLabelPrint') + moment().format('YYYY-MM-DD')}.xlsx`, this);
        },
    },
    mounted() {
        this.getSRMInvLovListNew((data) => {
            this.getFormDataItemObj(this.formData.items, 'orgCode').options.values = data.map((item) => { 
                return {
                    value: item.organizationCode,
                    label: item.organizationName,
                };
             });
        });
        this.getFormDataItemObj(this.formData.items, 'vendorCode').value = this.vendorCode;
        this.getFormDataItemObj(this.formData.items, 'vendorNameAlt').value = this.getVendorInfo().shortName;
        this.importUrl += `?vendorCode=${this.vendorCode}&language=${this.language}`;
    },
};
</script>
